import { render, staticRenderFns } from "./RulesTab.vue?vue&type=template&id=6f267b6c&scoped=true"
import script from "./RulesTab.vue?vue&type=script&lang=js"
export * from "./RulesTab.vue?vue&type=script&lang=js"
import style0 from "./RulesTab.vue?vue&type=style&index=0&id=6f267b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f267b6c",
  null
  
)

export default component.exports